'use strict';

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var pSeries = require('p-series');

var PeerMonitor = require('ipfs-pubsub-peer-monitor');

var Logger = require('logplease');

var logger = Logger.create("pubsub", {
  color: Logger.Colors.Yellow
});
Logger.setLogLevel('ERROR');
var maxTopicsOpen = 256;
var topicsOpenCount = 0;

var IPFSPubsub =
/*#__PURE__*/
function () {
  function IPFSPubsub(ipfs, id) {
    _classCallCheck(this, IPFSPubsub);

    this._ipfs = ipfs;
    this._id = id;
    this._subscriptions = {};
    if (this._ipfs.pubsub === null) logger.error("The provided version of ipfs doesn't have pubsub support. Messages will not be exchanged.");
    this._handleMessage = this._handleMessage.bind(this); // Bump up the number of listeners we can have open,
    // ie. number of databases replicating

    if (this._ipfs.setMaxListeners) this._ipfs.setMaxListeners(maxTopicsOpen);
  }

  _createClass(IPFSPubsub, [{
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(topic, onMessageCallback, onNewPeerCallback) {
        var _this = this;

        var topicMonitor;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._subscriptions[topic] && this._ipfs.pubsub)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 3;
                return this._ipfs.pubsub.subscribe(topic, this._handleMessage);

              case 3:
                topicMonitor = new PeerMonitor(this._ipfs.pubsub, topic);
                topicMonitor.on('join', function (peer) {
                  logger.debug("Peer joined ".concat(topic, ":"));
                  logger.debug(peer);

                  if (_this._subscriptions[topic]) {
                    onNewPeerCallback(topic, peer);
                  } else {
                    logger.warn('Peer joined a room we don\'t have a subscription for');
                    logger.warn(topic, peer);
                  }
                });
                topicMonitor.on('leave', function (peer) {
                  return logger.debug("Peer ".concat(peer, " left ").concat(topic));
                });
                topicMonitor.on('error', function (e) {
                  return logger.error(e);
                });
                this._subscriptions[topic] = {
                  topicMonitor: topicMonitor,
                  onMessage: onMessageCallback,
                  onNewPeer: onNewPeerCallback
                };
                topicsOpenCount++;
                logger.debug("Topics open:", topicsOpenCount);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function subscribe(_x, _x2, _x3) {
        return _subscribe.apply(this, arguments);
      };
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(hash) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._subscriptions[hash]) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return this._ipfs.pubsub.unsubscribe(hash, this._handleMessage);

              case 3:
                this._subscriptions[hash].topicMonitor.stop();

                delete this._subscriptions[hash];
                logger.debug("Unsubscribed from '".concat(hash, "'"));
                topicsOpenCount--;
                logger.debug("Topics open:", topicsOpenCount);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function unsubscribe(_x4) {
        return _unsubscribe.apply(this, arguments);
      };
    }()
  }, {
    key: "publish",
    value: function publish(topic, message) {
      if (this._subscriptions[topic] && this._ipfs.pubsub) {
        this._ipfs.pubsub.publish(topic, Buffer.from(JSON.stringify(message)));
      }
    }
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var topics;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                topics = Object.keys(this._subscriptions);
                _context3.next = 3;
                return pSeries(topics.map(function (t) {
                  return _this2.unsubscribe.bind(_this2, t);
                }));

              case 3:
                this._subscriptions = {};

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function disconnect() {
        return _disconnect.apply(this, arguments);
      };
    }()
  }, {
    key: "_handleMessage",
    value: function () {
      var _handleMessage2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(message) {
        var content, subscription, topicId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(message.from === this._id)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                try {
                  // Get the topic
                  topicId = message.topicIDs[0];
                  content = JSON.parse(message.data);
                  subscription = this._subscriptions[topicId];
                } catch (e) {
                  logger.error(e);
                  logger.error('Couldn\'t parse pubsub message:', message);
                }

                if (!(subscription && subscription.onMessage && content)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return subscription.onMessage(topicId, content);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function _handleMessage(_x5) {
        return _handleMessage2.apply(this, arguments);
      };
    }()
  }]);

  return IPFSPubsub;
}();

module.exports = IPFSPubsub;